module.exports = __webpack_public_path__ + "media/images/flags/mi-70afbf38b1313feec96de74bd39e78fc.png";